import { types as t } from 'mobx-state-tree';

export const Paragraph = t.model('Paragraph', {
  content: t.optional(t.maybeNull<any>(t.string), ''),
});
